import React, { useState } from 'react'
import filterIcon from "../../../../assets/img/admin/setting-4.svg";
import sortIcon from "../../../../assets/img/admin/sort.svg";
import Button from "../../../shared/Button";
import AdminBlogCard from './AdminBlogCard';
import AdminBlogCat from './AdminBlogCat';
const AdminBlog = () => {
    const [activeid, setactiveid] = useState(1);

  return (
    <div>
        <AdminBlogCat />
         <h2 className="text-[36px] font-[700] text-[#12171C]">
         مقالات سایت
      </h2>
      <div className="flex justify-between items-center mt-[32px] mb-[40px]">
        <div className="flex gap-[36px]">
          <button
            className={`text-[15px] font-[500] ${activeid === 1
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
          مقالات تایید شده
          </button>
          <button
            className={`text-[15px] font-[500] ${activeid === 2
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
          مقالات تایید نشده
          </button>
        
        </div>
        <div className="flex gap-[16px]">
            <Button varient="outline-gray">
                <div className="flex gap-[5px]">
                    <img src={filterIcon}/>
                    <p>فیلتر</p>

                </div>
            </Button>
            <Button className="button__gray ">
                <div className="flex gap-[5px]">
                    <img src={sortIcon}/>
                    <p>مرتب سازی</p>

                </div>
            </Button>
        </div>
      </div>
      <div>
        <AdminBlogCard />
        <AdminBlogCard />
        <AdminBlogCard />
        <AdminBlogCard />
        <AdminBlogCard />
        <AdminBlogCard />

      </div>


    </div>
  )
}

export default AdminBlog